import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/core/styles";
import { Divider, TextField } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CustomInput from "../../../../../../../Components/CustomInput";
import Loader from "../../../../../../../Components/Loader";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import DataService from "../../../../../../../Service";
import SunEditor, { plugins } from "suneditor-react";
import CustomSelectMulti from "../../../../../../../Components/CustomSelectMulti";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../../../Components/Snackbar/SnackbarActions";
import { Autocomplete } from "@material-ui/lab";

const emailRegExp = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
  },
  title: {
    textTransform: "capitalize",
  },
  dialog_title: {
    "& h6": {
      fontWeight: "700",
    },
  },
  textAreaEmpty: {
    color: "rgba(0, 0, 0, 0.87)",
    width: "94%",
    border: "1px solid rgb(196 196 196)",
    padding: "10px",
    borderRadius: "4px",
    font: "inherit",
    display: "block",
    outline: "none",

    "&:focus": {
      border: "2px solid #3B86FF",
    },
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    "& span:last-child": {
      fontSize: "13px",
      color: "#303030",
    },
    "& svg": {
      width: "1.2em",
      height: "1.2em",
    },
  },
  sendToEmail: {
    "& .Mui-disabled": {
      color: "rgba(0, 0, 0, 0.87)",
    },
  },
  ccToEmail: {
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] ': {
      padding: 0,
    },
  },
}));

const LongListEmailModal = (props) => {
  const classes = useStyles();
  const { isOpen, onClose, pageData, contentType, sendEmailContentType } =
    props;
  const dispatch = useDispatch();
  const location = useLocation();
  const [emailAddress, setEmailAddress] = useState([]);
  const [inputValue, setInputValue] = useState({});
  const [textEditorValue, setTextEditorValue] = useState(undefined);
  const [sendToEmail, setSendToEmail] = useState({
    emailValue: "Fetching...",
    setBy: "default",
  });
  const [ccToArray, setCCToArray] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);

  useEffect(() => {
    fetchEmailAddresses();
    fetchEmailContent();
    fetchSendToEmail();
  }, []);

  const fetchSendToEmail = () => {
    let param = {
      user_ids: pageData?.coach_id,
    };
    DataService.getData(param, "sendToEmailShortlist")
      .then((res) => {
        if (res?.success) {
          setSendToEmail({
            emailValue: res.data.to_email_address,
            setBy: "fetch",
          });
          clearEmailInputError("sendTo");
        }
      })
      .catch((error) => {
        setSendToEmail({ emailValue: "", setBy: "fetch" });
        setEmailInputError(
          "sendTo",
          "Couldn't fetch email id for the selected coach.Please enter it manually"
        );
      });
  };

  const fetchEmailAddresses = () => {
    DataService.getData(
      { assignment_id: location?.state?.currentAssignment?.id },
      "listStakeholdersEmail"
    )
      .then((res) => {
        if (res?.success) {
          res?.email_address?.map((data) => {
            return (data["value"] = data?.email);
          });
          setEmailAddress(res?.["email_address"]);
        }
      })
      .catch((error) => {
        console.log("error =>", error);
      });
  };
  const fetchEmailContent = () => {
    let param = {
      assignment_id: location?.state?.currentAssignment?.id,
      content_type: contentType,
      user_ids: [pageData?.coach_id],
    };
    DataService.getData(param, "get_email_content")
      .then((res) => {
        if (res?.success) {
          setInputValue({ subject: res?.subject });
          setTextEditorValue(res?.content || "");
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error =>", error);
        setLoading(false);
      });
  };

  const sendMail = (e) => {
    e.preventDefault();
    if (inputErrors.sendTo.isError) {
      dispatch(showSnackbar("error", ["Please enter a valid email id"], 1000));
    } else {
      setIsSubmit(true);
      setLoading(true);
      let param = {
        assignment_id: location?.state?.currentAssignment?.id,
        content_type: sendEmailContentType || "",
        to_email_address: [sendToEmail.emailValue],
        cc_email_address: ccToArray?.length
          ? ccToArray.map((item) => item.email)
          : [],
        subject: inputValue?.subject,
        content: textEditorValue,
      };
      if (pageData.coach_id) {
        param.user_ids = pageData.coach_id;
      }
      DataService.createData(param, "coachesSendEmail")
        .then((res) => {
          if (res?.success) {
            dispatch(showSnackbar("success", [res?.message]));
            onClose();
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log("error =>", error);
          dispatch(showSnackbar("success", [error?.message ?? ""]));
          setLoading(false);
        });
    }
  };

  const handleChangeInputValue = (value, name) => {
    setInputValue({ ...inputValue, [name]: value });
  };

  const handleChangeTextEditorData = (content) => {
    setTextEditorValue(content);
  };
  const [inputErrors, setInputErrors] = useState({
    sendTo: {
      isError: false,
      errorMsg: "",
    },
    ccTo: {
      isError: false,
      errorMsg: "",
    },
  });

  const setEmailInputError = (emailType, errorMsg = "") => {
    setInputErrors((prev) => {
      const oldObj = { ...prev };
      oldObj[emailType].isError = true;
      oldObj[emailType].errorMsg = errorMsg;
      return oldObj;
    });
  };
  const clearEmailInputError = (emailType, errorMsg = "") => {
    setInputErrors((prev) => {
      const oldObj = { ...prev };
      oldObj[emailType].isError = false;
      oldObj[emailType].errorMsg = errorMsg;
      return oldObj;
    });
  };

  const handleCCEmail = (event, newValue, added) => {
    const toBeUpdated = newValue
      .map((el, ind) => {
        if (typeof el === "object") {
          clearEmailInputError("ccTo");
          return el;
        }
        if (typeof el === "string") {
          if (new RegExp(emailRegExp).test(el)) {
            if (
              newValue.length > 0 &&
              newValue.slice(0, ind).findIndex((elem) => elem.value === el) !==
                -1
            ) {
              setEmailInputError("ccTo", "Email already exists");
              setTimeout(() => {
                clearEmailInputError("ccTo");
              }, 3000);
              return -1;
            }
            clearEmailInputError("ccTo");
            return {
              id: el,
              value: el,
              email: el,
            };
          } else {
            setEmailInputError("ccTo", "Please enter a valid email");
            setTimeout(() => {
              clearEmailInputError("ccTo");
            }, 3000);
            return -1;
          }
        }
      })
      .filter((el) => el !== -1);
    setCCToArray(toBeUpdated);
  };

  const handleSendToEmail = (e) => {
    const enteredValue = e.target.value;
    if (new RegExp(emailRegExp).test(enteredValue)) {
      clearEmailInputError("sendTo");
    } else {
      setEmailInputError("sendTo", "Please enter valid email id");
    }
    setSendToEmail({
      emailValue: enteredValue,
      setBy: "input",
    });
  };
  return (
    <>
      <Dialog
        style={{ zIndex: 1301 }}
        maxWidth={"md"}
        fullWidth={true}
        open={isOpen}
        onClose={() => onClose()}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle
          id="customized-dialog-title"
          className={classes.dialog_title}
        >
          Send email
        </DialogTitle>
        <Divider />
        <DialogContent style={{ margin: "0px auto" }}>
          {loading && <Loader />}
          <div className={classes.formWrapper}>
            <div>
              <Grid
                container
                spacing={1}
                justify={"flex-start"}
                style={{ marginBottom: 10 }}
              >
                <Grid item xs={2} alignItems={"flex-start"}>
                  <Typography variant="subtitle2" className={classes.title}>
                    Send to
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    disabled={
                      sendToEmail.emailValue !== "" &&
                      sendToEmail.setBy === "fetch"
                    }
                    placeholder="Please enter a email id"
                    onChange={handleSendToEmail}
                    error={inputErrors.sendTo.isError}
                    helperText={inputErrors.sendTo.errorMsg}
                    value={sendToEmail.emailValue}
                    title="Email id of the coach selected"
                    className={classes.sendToEmail}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-start"}
                style={{ marginBottom: 10 }}
              >
                <Grid item xs={2}>
                  <Typography variant="subtitle2" className={classes.title}>
                    CC to
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Grid xs={12}>
                    <Autocomplete
                      options={emailAddress}
                      value={ccToArray}
                      defaultValue={ccToArray}
                      multiple
                      filterSelectedOptions
                      onChange={handleCCEmail}
                      fullWidth
                      getOptionLabel={(el) => {
                        return el.value;
                      }}
                      className={classes.ccToEmail}
                      freeSolo
                      renderInput={(params) => {
                        return (
                          <TextField
                            {...params}
                            placeholder="Search by name or email"
                            variant={"outlined"}
                            error={inputErrors.ccTo.isError}
                            helperText={inputErrors.ccTo.errorMsg}
                          />
                        );
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-start"}
                style={{ marginBottom: 10 }}
              >
                <Grid item xs={2}>
                  <Typography variant="subtitle2" className={classes.title}>
                    Subject
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <FormControl style={{ width: "100%" }} variant="outlined">
                    <CustomInput
                      id="subject"
                      name="subject"
                      placeholder="Subject"
                      labelText="Subject"
                      variant="outlined"
                      parentcall={handleChangeInputValue}
                      value={inputValue?.subject}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-start"}
                style={{ marginBottom: 10 }}
              >
                <Grid item xs={2}></Grid>
                <Grid item xs={10} style={{ zIndex: 0 }}>
                  {textEditorValue !== undefined && (
                    <FormControl style={{ width: "100%" }} variant="outlined">
                      <SunEditor
                        width="100%"
                        setOptions={{
                          height: 300,
                          plugins: plugins,
                          buttonList: [
                            ["undo", "redo"],
                            ["font", "fontSize", "formatBlock"],
                            ["paragraphStyle", "blockquote"],
                            ["bold", "underline", "italic", "strike"],
                            ["fontColor", "hiliteColor", "textStyle"],
                            "/",
                            ["outdent", "indent"],
                            ["align", "horizontalRule", "list", "lineHeight"],
                            ["table", "link", "image" /** ,'math' */],
                            ["fullScreen", "codeView"],
                            ["preview"],
                            ["save", "template"],
                          ],
                          defaultStyle: "font-family:Arial",
                        }}
                        name="content"
                        onChange={handleChangeTextEditorData}
                        placeholder="Please type here..."
                        autoFocus={true}
                        defaultValue={textEditorValue}
                        setContents={textEditorValue}
                      />
                    </FormControl>
                  )}
                </Grid>
              </Grid>

              <Grid
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-end"}
                style={{ marginTop: 20 }}
              >
                <Grid style={{ marginRight: "2rem" }} item xs={1}>
                  <Button
                    disableElevation
                    type="button"
                    style={{ textTransform: "capitalize" }}
                    onClick={() => {
                      onClose();
                    }}
                    variant={"contained"}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={1}>
                  <Button
                    disableElevation
                    onClick={sendMail}
                    style={{ textTransform: "capitalize" }}
                    variant={"contained"}
                    color="primary"
                  >
                    {"Send"}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LongListEmailModal;
